module.exports = __webpack_public_path__ + "static/media/solar_system.a0dd4dc0.svg";